export default function menuStyle() {
  return (styles) => ({
    ...styles,
    width: 'unset',
    left: '0px'
  });
}
